module.exports = __webpack_public_path__ + "static/sy-b914d735d560005b8ef5733039444ddd.jpg";